import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box} from '@material-ui/core';
import {Table, TableBody, TableCell, LinearProgress, TableContainer, TableHead, TableRow, Paper} from '@mui/material';
///import {Edit, Autorenew, AddTask} from '@mui/icons-material';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Portal from '@mui/material/Portal';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DeleteAlert from '../components/DeleteAlert'; 
///import MocktestMngtSave from './TopictestMngtSave';
import Cookies from 'js-cookie';
import axios from 'axios';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div className="btmbdrgry"><h3>{children}</h3></div>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const userObj = useSelector(state => state.userDetails);
  // const childRefSave = React.useRef();
  const [pageLoading, setPageLoading] = React.useState(true);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false);

  const [index, setIndex] = React.useState(-1);
  const [rows, setRows] = React.useState([]);  
  // const [dataObj, setDataObj] = React.useState({});
  

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}


  React.useEffect(() => {	
    setSaveLoading(false);
    setIndex(-1);
    if(open && props.dataObj && props.dataObj.autoId && userObj && userObj.loginId){	
      getApiData();    
    }
	}, [open,props.dataObj,userObj]);

	async function getApiData(){
    setPageLoading(false); 
      let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 
			
			axios.get(env.API_URL+"/exams/read/topictest-instances?topictestMngtId="+props.dataObj.autoId, axiosHeader) 
			   .then(response => {
				 setPageLoading(false); 
				if(response.data && response.data.responseTxt==="invalidToken"){ 
					Cookies.remove('isadminloggedin');
					window.location.href='login';
				}else if(response.data && response.data.responseTxt==="success"){
					setRows(response.data.obj);
				}		
			})
			// .catch((error) => {
			// 	alert("ERROR: ", error);
			// })	
	}



  // function add() {
  //   setDataObj({});
  //   childRefSave.current.handleClickOpen();
  // }
  // function edit(obj) {
  //   setDataObj(obj);
  //   childRefSave.current.handleClickOpen();
  // }

  function deleteNow(obj){
		if(obj && userObj.token){
			let axiosHeader = {
					headers: {
            'Content-Type': 'multipart/mixed',
            'loginId': userObj.loginId,
					  'token': userObj.token,
					  'device': 'web'
				}
			}; 

		  const data = new FormData();
		  data.append('id', obj.autoId);
      data.append('topictestMngtId', obj.topictestMngtId);
      
		  axios.post(env.API_URL+'/exams/delete/topictest-instances', data, axiosHeader)
				.then((response) => {
          if(response.data && response.data.responseTxt==="invalidToken"){ 
            Cookies.remove('isadminloggedin');
            window.location.href='login';
          }else if(response.data && response.data.responseTxt==="success"){
            if(open && props.dataObj && props.dataObj.autoId && userObj && userObj.loginId){	
              getApiData();    
            }
            setSeverityAlert("success");
            setShowAlert(true);
            setAlertMessage("Topic test instance has been deleted.");
          }else{
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("Topic test instance could not be deleted.");			
            return false;
          }	
			})
		}				
	}

  
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}>{props.dataObj.topictestTitle}: Instances</DialogTitle>
          <DialogContent >
          {pageLoading?<LinearProgress />:null}
          <Box mt={2}>
          <Grid container  >            
            <Grid item md={12} xs={12} >
            {(rows && rows.length>0)?  
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableHead> 
                    <TableRow>
                      <TableCell style={{whiteSpace: 'nowrap'}} ><b>Topic test Title</b></TableCell>
                      {/* <TableCell style={{whiteSpace: 'nowrap'}} ><b>No Of Question</b></TableCell> */}
                      <TableCell sx={{ width: 80 }}>&nbsp;</TableCell>           
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row,i) => (
                      <TableRow
                        key={row.autoId}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      > 
                        <TableCell style={{whiteSpace: 'nowrap'}} >{row.topictestTitle}</TableCell>
                        {/* <TableCell style={{whiteSpace: 'nowrap'}} >{row.noOfQuestion}</TableCell> */}
                        <TableCell align="center" style={{verticalAlign:'top'}}>
                          {(saveLoading && index===i)?<CircularProgress color="primary" size={20} />:<>
                              <DeleteAlert deleteNow={deleteNow} dataObj={row} text={'Are you sure, You want to delete.'} className='iconGraySmall' />
                              <br/>
                              
                          </>}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            :null}

            </Grid>
          </Grid>  
        </Box>

        {(!rows || rows.length<1)?<div className='nrfbox' >No Instance found</div>:null}


       </DialogContent>
      </Dialog>
      
      <Portal>
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>
      </Portal>


    </>
  );

});

export default CustomizedDialogs;